var map = {
	"./0 a.png": 7488,
	"./0.png": 6547,
	"./1 a.png": 1792,
	"./1.png": 1199,
	"./2 a.png": 106,
	"./2.png": 4151,
	"./3 a.png": 6142,
	"./3.png": 3110,
	"./4 a.png": 3629,
	"./4.png": 9051,
	"./5 a.png": 4357,
	"./5.png": 2375,
	"./6 a.png": 1298,
	"./6.png": 6250,
	"./7 a.png": 5799,
	"./7.png": 7695,
	"./8 a.png": 5399,
	"./8.png": 9307,
	"./9 a.png": 5756,
	"./9.png": 8967,
	"./BG new 2.png": 3199,
	"./CEX.png": 105,
	"./Copy of token-05.png": 383,
	"./DEX.png": 4447,
	"./FBlogo.png": 6979,
	"./Group 120.png": 1151,
	"./Group 126.png": 4394,
	"./Group 127.png": 8224,
	"./Group 128.png": 8517,
	"./Group 129.png": 7120,
	"./Group 130.png": 2250,
	"./Group 131.png": 725,
	"./Group 160.png": 5606,
	"./Group 161.png": 8219,
	"./Group 164.png": 4350,
	"./Group 4.png": 6522,
	"./Group 5.png": 3798,
	"./Group 6.png": 2490,
	"./Group 7.png": 67,
	"./Group-5.png": 6832,
	"./Group-6.png": 4221,
	"./Group-7.png": 4524,
	"./Indexx Token.png": 8651,
	"./IndexxToken.png": 170,
	"./Polygon.png": 4240,
	"./about.png": 4722,
	"./affiliate.png": 6284,
	"./aline.png": 5426,
	"./assets/1.png": 7510,
	"./assets/2.png": 6309,
	"./assets/3.png": 5615,
	"./assets/4.png": 1502,
	"./assets/ADA.png": 7382,
	"./assets/ALGO.png": 2552,
	"./assets/BNB.png": 3482,
	"./assets/BTC.png": 4796,
	"./assets/BTCB.png": 4057,
	"./assets/Ball-024-01png.png": 8193,
	"./assets/CEX.png": 3229,
	"./assets/DEX.png": 6169,
	"./assets/ENJ.png": 4479,
	"./assets/ETH.png": 8841,
	"./assets/FBlogo.png": 3501,
	"./assets/FTT.png": 681,
	"./assets/IN500.png": 3808,
	"./assets/INEX.png": 1522,
	"./assets/INXC.png": 9902,
	"./assets/INXP.png": 9064,
	"./assets/IUSD+.png": 7752,
	"./assets/IUSD.png": 2705,
	"./assets/Indexx Token.png": 1484,
	"./assets/LTC.png": 5713,
	"./assets/ML.png": 5828,
	"./assets/Polygon.png": 4966,
	"./assets/UI-bg.png": 2483,
	"./assets/UNI.png": 6953,
	"./assets/USD.png": 8469,
	"./assets/Wales.png": 7425,
	"./assets/about.png": 515,
	"./assets/affiliate.png": 2730,
	"./assets/arrows.png": 8847,
	"./assets/bank.png": 6956,
	"./assets/bg33.png": 6104,
	"./assets/bgForUi.png": 6689,
	"./assets/binancew.png": 5010,
	"./assets/blog.png": 6501,
	"./assets/bnb1.png": 626,
	"./assets/bnblogo2.png": 3771,
	"./assets/cam2 copy.png": 6635,
	"./assets/cam2.png": 9820,
	"./assets/career.png": 5755,
	"./assets/clock.png": 7785,
	"./assets/coinbase2.png": 2306,
	"./assets/confirm.png": 8455,
	"./assets/confirm1.png": 1569,
	"./assets/dex4t2e copy.png": 9735,
	"./assets/dex4t2e.png": 322,
	"./assets/dollar.png": 3735,
	"./assets/earn.png": 5826,
	"./assets/eth1.png": 4801,
	"./assets/exchange.png": 2828,
	"./assets/exchange1.png": 6270,
	"./assets/exgcoin.png": 3914,
	"./assets/exghands.png": 8460,
	"./assets/fb.png": 5423,
	"./assets/fortune Daily.png": 505,
	"./assets/fortune-10.png": 7548,
	"./assets/fortune-12.png": 3169,
	"./assets/four.png": 8022,
	"./assets/graph.png": 1814,
	"./assets/green.png": 3068,
	"./assets/green2.png": 4932,
	"./assets/green3.png": 9313,
	"./assets/green4.png": 929,
	"./assets/header-icons/Company/about.png": 4143,
	"./assets/header-icons/Company/affiliate.png": 8702,
	"./assets/header-icons/Company/blog.png": 4959,
	"./assets/header-icons/Company/career.png": 4594,
	"./assets/header-icons/Company/howitworks.png": 9730,
	"./assets/header-icons/Company/hybrid.png": 290,
	"./assets/header-icons/Earn/iGrow.png": 6548,
	"./assets/header-icons/Earn/t2e.png": 922,
	"./assets/header-icons/Fortune/fortune.png": 7610,
	"./assets/header-icons/Fortune/hedge.png": 5715,
	"./assets/header-icons/Products/CEX.png": 7050,
	"./assets/header-icons/Products/DEX.png": 8345,
	"./assets/header-icons/Products/IndexxToken.png": 1790,
	"./assets/header.png": 6757,
	"./assets/hedge.png": 9027,
	"./assets/how it works.png": 4339,
	"./assets/hybrid.png": 6185,
	"./assets/iGrow.png": 9891,
	"./assets/indexx.png": 3208,
	"./assets/indexx500.png": 7154,
	"./assets/indexxGrey.png": 3828,
	"./assets/inst2.png": 9817,
	"./assets/ladySwapIcon.png": 2961,
	"./assets/logo.png": 4780,
	"./assets/logonew.png": 3302,
	"./assets/metamask.png": 4213,
	"./assets/need.png": 5937,
	"./assets/new.png": 5822,
	"./assets/newFooter.png": 9654,
	"./assets/no11.png": 3186,
	"./assets/no22.png": 7932,
	"./assets/no3.png": 135,
	"./assets/one.png": 9237,
	"./assets/pending.png": 1833,
	"./assets/pending1.png": 6876,
	"./assets/petFooter.png": 4029,
	"./assets/please.png": 1040,
	"./assets/qr.png": 1467,
	"./assets/question.png": 4698,
	"./assets/redit2.png": 3560,
	"./assets/send1.png": 9830,
	"./assets/sending.png": 2071,
	"./assets/swap.png": 5825,
	"./assets/telegram.png": 8052,
	"./assets/text.png": 8820,
	"./assets/three.png": 6620,
	"./assets/trust.png": 6124,
	"./assets/twit2.png": 2328,
	"./assets/two.png": 8205,
	"./assets/vector.png": 996,
	"./assets/wallet.png": 4854,
	"./assets/white copy.png": 6822,
	"./assets/white.png": 4013,
	"./assets/yt1.png": 1317,
	"./bank.png": 1739,
	"./bg33.png": 2776,
	"./blog.png": 9966,
	"./buy.png": 8020,
	"./buyi.png": 9693,
	"./cam2.png": 2721,
	"./career.png": 6851,
	"./changed.png": 4980,
	"./checkorange.png": 8149,
	"./cross.png": 9152,
	"./dex4t2e.png": 3102,
	"./editt.png": 24,
	"./fortune-10.png": 3127,
	"./fortune-16.png": 124,
	"./fortune.png": 2652,
	"./fourthh.png": 7612,
	"./gggg.png": 4448,
	"./graph.png": 6477,
	"./hands-12.png": 482,
	"./hands-20.png": 1171,
	"./hands-29.png": 7706,
	"./hedge.png": 8933,
	"./home_page_logo.png": 6732,
	"./howitworks.png": 4974,
	"./htp.png": 6144,
	"./htp2.png": 2484,
	"./htp2n.png": 5053,
	"./htpf.png": 3572,
	"./hybrid.png": 3997,
	"./iGrow.png": 4325,
	"./icons.png": 7369,
	"./image1.png": 6487,
	"./image2.png": 9922,
	"./image3.png": 6177,
	"./indexx.png": 3389,
	"./indexxGrey.png": 5405,
	"./inst2.png": 3671,
	"./lady.png": 4999,
	"./ladySwapIcon.png": 5522,
	"./left.png": 332,
	"./left22.png": 1023,
	"./log.png": 7941,
	"./logo.png": 6949,
	"./mid.png": 1780,
	"./need copy.png": 9055,
	"./need.png": 427,
	"./new.png": 4230,
	"./newFooter.png": 2654,
	"./pf.png": 8720,
	"./pfF.png": 4643,
	"./pfp.png": 7092,
	"./pfp2.png": 6775,
	"./ppp.png": 9367,
	"./prize funds new.png": 1214,
	"./purple-1.png": 5265,
	"./purple.png": 983,
	"./redit2.png": 7664,
	"./right.png": 1132,
	"./right22.png": 960,
	"./secondd.png": 4199,
	"./stars 1.png": 1309,
	"./t2e.png": 1975,
	"./telegram.png": 4762,
	"./thirdd.png": 8999,
	"./ticket.png": 6093,
	"./token.png": 3678,
	"./tokenimgg.png": 9438,
	"./topp.png": 9559,
	"./twit2.png": 4911,
	"./wc.png": 7865,
	"./wcF.png": 1883,
	"./whale4.png": 9537,
	"./white.png": 1477,
	"./x orange.png": 2109,
	"./yt1.png": 2926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;